import React from "react";
import Logo from "../assets/images/Logo.png";
import { useHistory } from "react-router-dom";

function Footer() {
  const history = useHistory();
  return (
    <div className="Footer">
      <div className="container">
        <div className="mainFooter">
         
        </div>
        
           
           
             
            
            
          
        
        <div className="footerEnd text-center">
          <p className="para">
            <i className="far fa-copyright"></i> 2022 SolSurvivor Club
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
